import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import React from "react";
import Dashboard from "../bbdd/Dashboard";
import Problemes from "../bbdd/problemes/Problemes";
import ProblemesId from "../bbdd/problemesId/ProblemesId";
import Activitats from "../bbdd/problemes/content/Activitats";
import ActivitatsId from "../bbdd/activitatsId/ActivitatsId";
import AlumnesId from "../bbdd/activitatsIdAlumnesId/AlumnesId";

import Notes from "../bbdd/problemes/content/Notes";
import Ranking from "../bbdd/problemes/content/Ranking";
import Pildores from "../bbdd/problemes/content/Pildores";
import IdeBbddFrame from "../bbdd/ide/IdeBbddFrame";
import AulesDatabases from "../bbdd/aulesDatabases/AulesDatabases";

const AppJutgeRoutes = () => {

    return (
        <Routes>
            <Route path="/" element={<Dashboard/>}/>
            <Route path="/problemes" element={<Problemes/>}/>
            <Route path="/activitats" element={<Activitats/>}/>
            <Route path="/examens" element={<Activitats onlyExams={true}/>}/>
            <Route path="/aules-bbdd" element={<AulesDatabases/>}/>
            <Route path="/notes" element={<Notes/>}/>
            <Route path="/ranking" element={<Ranking/>}/>
            <Route path="/pildores" element={<Pildores/>}/>
            <Route path="/ide/frame" element={<IdeBbddFrame/>}/>
            <Route path="/problemes/:id_problema" element={<ProblemesId/>}/>
            <Route path="/activitats/:id_activitat" element={<ActivitatsId page={0}/>}/>
            <Route path="/activitats/:id_activitat/alumnes" element={<ActivitatsId page={1}/>}/>
            <Route path="/activitats/:id_activitat/problemes/:id_problema" element={<ProblemesId/>}/>
            <Route path="/activitats/:id_activitat/alumnes/:id_alumne" element={<AlumnesId/>}/>
            <Route path="*" element={<Navigate to="/" replace/>}/>
        </Routes>
    );
}

export default AppJutgeRoutes;
